<template>
    <v-progress-circular
        v-if="participant.running === true"
        :value="progressPercent(participant)"
        :color="progressColor(participant)"
    ></v-progress-circular>
    <v-btn icon v-else>
        <v-icon color="green" v-if="participant.presenceStatus === true">fal fa-check</v-icon>
        <v-icon color="red" v-else>fal fa-times-circle</v-icon>
    </v-btn>
</template>

<script>
    export default {
        name: 'ParticipantStatus',
        props: {
            participant: Object
        },
        computed: {
            categories () {
                return this.$store.state.categories
            },
        },
        methods: {
            progressPercent (participant) {
                if (participant.canceled === true) {
                    return 100
                }
                if (participant.progress === 0) {
                    return 0
                }

                const maxCheckpoints = this.categories.find(category => {
                    if (category.id === participant.category) {
                        return category.checkpoints.length
                    }
                })

                return (participant.progress / maxCheckpoints.checkpoints.length * 100).toFixed(0)
            },
            progressColor (participant) {
                if (participant.canceled === true) {
                    return 'error'
                } else if (participant.running === true) {
                    return 'success'
                }

                return 'warning'
            }
        }
    }
</script>

<style>

</style>
